import script from "./DownloadImage.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadImage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__